angular
  .module('contrast.services.rule', [])
  .factory('RuleService', function (AGENT_LANGUAGE, $translate) {
    'ngInject'

    var translGlobal = {
      title_allRules: $translate.instant('title_allRules')
    }

    var ALL_OPTION = 'All Rules'
    var validAPI = { result: true }
    var invalidAPI = { result: false }

    var DOTNET_REF = 'ref'

    const DOTNET_GENERIC_RETURN_TYPE_REGEX = /^[A-Z](\[\])?/
    const DOTNET_PARAMETER_REGEX = /^((ref\s\S+)|(out\s\S+)|\S+)$/

    function validateDotNetSignature(value, apiLanguage) {
      var returnTypeEndIndex = getDotNetReturnTypeEnd(value)
      if (returnTypeEndIndex === -1 || value.length <= returnTypeEndIndex + 1) {
        return invalidAPI
      }

      var returnType = value.substring(0, returnTypeEndIndex)
      if (validateDotNetReturnType(returnType)) {
        var methodName = value.substring(returnTypeEndIndex + 1)
        // other than the return method, validation is the same as java
        return isValidApi(methodName, apiLanguage)
      } else {
        return invalidAPI
      }
    }

    function getDotNetReturnTypeEnd(value) {
      var firstSpaceIndex = value.indexOf(' ')
      return !value.startsWith(DOTNET_REF)
        ? firstSpaceIndex
        : value.indexOf(' ', firstSpaceIndex + 1)
    }

    function validateDotNetReturnType(returnType) {
      if (returnType.length < 1) {
        return false
      }

      if (returnType === 'void') {
        return true
      }

      var splitValue = returnType.split(' ')
      var type

      if (splitValue.length > 1) {
        if (splitValue[0] !== DOTNET_REF) {
          return false
        }
        type = splitValue[1]
      } else {
        type = splitValue[0]
      }

      return (
        type.indexOf('.') !== -1 || DOTNET_GENERIC_RETURN_TYPE_REGEX.test(type)
      )
    }

    function isValidApi(value, apiLanguage) {
      var isGenerallyOkay = value.indexOf(' ') == -1
      var isJava = _.includes(AGENT_LANGUAGE.JAVA, apiLanguage)
      var isDotNet =
        !isJava &&
        (_.includes(AGENT_LANGUAGE.DOTNET, apiLanguage) ||
          _.includes(AGENT_LANGUAGE.DOTNET_CORE, apiLanguage))

      if (!isGenerallyOkay && !isDotNet) {
        return invalidAPI
      }
      var validateLanguage = isJava || isDotNet || !apiLanguage
      var firstParen = value.lastIndexOf('(')
      if (firstParen == -1) {
        return invalidAPI
      }

      var lastDot = value.lastIndexOf('.', firstParen)
      if (validateLanguage && lastDot == -1) {
        return invalidAPI
      }

      var className = value.substring(0, lastDot)
      if (className == '' && validateLanguage) {
        return {
          result: false,
          message: $translate.instant(
            'validation_securityControlSignature_missingClassName'
          )
        }
      }

      var methodSig = value.substring(lastDot + 1)

      var mFirstParen = methodSig.lastIndexOf('(')
      var mLastParen = methodSig.lastIndexOf(')')
      if (mFirstParen == -1 || mLastParen == -1) {
        return {
          result: false,
          message: $translate.instant(
            'validation_securityControlSignature_missingParentheses'
          )
        }
      }

      var methodName = methodSig.substring(0, mFirstParen)
      if (methodName == '') {
        return {
          result: false,
          message: $translate.instant(
            'validation_securityControlSignature_missingMethodName'
          )
        }
      }

      var args = []
      var sArgs = methodSig.substring(mFirstParen + 1, mLastParen)
      if (sArgs.length != 0) {
        args = sArgs.split(',')
      }

      var markedParams = args.filter((arg) => arg.includes('*'))
      if (markedParams.length === 0) {
        return {
          result: false,
          message: $translate.instant(
            'validation_securityControlSignature_parameterNotMarked'
          )
        }
      } else if (markedParams.length > 1) {
        return {
          result: false,
          message: $translate.instant(
            'validation_securityControlSignature_multipleMarkedParameters'
          )
        }
      }

      var markedParameter = markedParams[0]

      /* The java agent only supports marked paramerters of type String. 
        See docs https://docs.contrastsecurity.com/en/edit-security-controls.html */
      if (isJava && markedParameter !== 'java.lang.String*') {
        return {
          result: false,
          message: $translate.instant(
            'validation_securityControlSignature_onlyJavaStringMarked'
          )
        }
      }

      if (isDotNet) {
        for (const arg of args) {
          if (!DOTNET_PARAMETER_REGEX.test(arg)) {
            return {
              result: false,
              message: $translate.instant(
                'validation_securityControlSignature_dotNetParametersInvalidFormat'
              )
            }
          }
        }
      }

      return validAPI
    }

    function removeAllOption(array) {
      var index = _.indexOf(array, ALL_OPTION)
      if (index != -1) {
        array = array
          .slice(0, index)
          .concat(array.slice(index + 1, array.length))
      }
      return array
    }

    return {
      validateApi: function (value, lang) {
        var apiLanguage = lang || AGENT_LANGUAGE.JAVA[0]

        if (
          _.includes(AGENT_LANGUAGE.DOTNET, apiLanguage) ||
          _.includes(AGENT_LANGUAGE.DOTNET_CORE, apiLanguage)
        ) {
          return validateDotNetSignature(value, apiLanguage)
        } else if (
          _.includes(AGENT_LANGUAGE.JAVA, apiLanguage) ||
          _.includes(AGENT_LANGUAGE.NODE, apiLanguage)
        ) {
          return isValidApi(value, apiLanguage)
        } else {
          return validAPI
        }
      },
      buildSelectWithRuleTitle: function (data) {
        var select = []
        angular.forEach(data, function (rule) {
          select.push({ value: rule.name, text: rule.title })
        })

        return select
      },
      onRulesUpdate: function ($scope, item, model) {
        if (model == ALL_OPTION) {
          $scope.model.rules = [
            { title: translGlobal.title_allRules, name: ALL_OPTION }
          ]
          $scope.control.all_rules = true
        } else {
          $scope.model.rules = removeAllOption($scope.model.rules)
          $scope.control.all_rules = false
        }
      },
      onRulesDelete: function ($scope) {
        if ($scope.model.rules.length == 0) {
          $scope.control.all_rules = true
          $scope.model.rules.push({
            title: translGlobal.title_allRules,
            name: ALL_OPTION
          })
        }
      }
    }
  })
